// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
.line-number-picker-panel {
  min-height: 156px;
  width: 332px;
  box-sizing: border-box;
}

.checkbox-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

.checkbox-container {
  display: flex;
  align-items: center;
  width: 95px;
  margin: 5px 0;
  vertical-align: top;
}

.select-all-row {
  display: flex;
  align-items: center;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #3f5061;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
